import React, { Component } from 'react';
import { Modal, Header, Button } from 'semantic-ui-react';
import { connect } from 'react-redux';

import { saveProhibitedItems } from '../state/actions';
import { SecurityPreferences } from 'Common/Security/SecurityPreferences';
import { PreferencesEnum as PrefEnum } from 'Common/Security/PreferencesEnum';
import { ProhibitedItemsGrid } from './ProhibitedItemsGrid';
import { MealTypePicker } from './MealTypePicker';

class ProhibitedItemsModalContainer extends Component {
  state = {
    mealType: 'B',
  };

  onMealTypeChange = mealType => {
    this.setState({ mealType });
  };

  onSaveClick = () => {
    const { saveProhibitedItems, student } = this.props;
    saveProhibitedItems(student.IdSeed);
  };

  render() {
    const { modalProps, student, loading, saving } = this.props;
    const { mealType } = this.state;
    const title = `Prohibited Items - ${student.FirstName} ${student.LastName}`;
    return (
      <Modal {...modalProps} closeIcon>
        <Header content={title} icon={'ban'} />
        <Modal.Content>
          <MealTypePicker onChange={this.onMealTypeChange} active={mealType} />
          <ProhibitedItemsGrid mealType={mealType} />
        </Modal.Content>
        <Modal.Actions>
          <SecurityPreferences scope={PrefEnum.ModifyProhibitedItems}>
            {disabled => {
              return (
                <Button
                  inverted
                  color="orange"
                  size="big"
                  content="Save"
                  onClick={this.onSaveClick}
                  disabled={saving || loading || disabled}
                  loading={saving}
                />
              );
            }}
          </SecurityPreferences>
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = ({ AccountSetupState }) => {
  return {
    loading: AccountSetupState.prohibitedItemsLoading,
    saving: AccountSetupState.prohibitedItemsSaving,
  };
};

export const ProhibitedItemsModal = connect(
  mapStateToProps,
  {
    saveProhibitedItems,
  }
)(ProhibitedItemsModalContainer);



// WEBPACK FOOTER //
// ./src/pages/accountsetup/components/ProhibitedItemsModal.js